export default __webpack_public_path__ + "static/media/Snd_ClowerJ.1283d4a0.mp3";